import { getData, getDataSimple, patchData, postData, putData } from "../../utils/serverHelper";
import { BILLING, COUPON, PAYMENT, PLANS } from "../../utils/urls";
import { errorMessage } from "../error/action";
import { failedBilling, failedCoupons, failedPlan, loadingAddCoupon, loadingBilling, loadingCoupons, loadingPlan, successBilling, successCoupons, successCouponsSingle, successPlan } from "./reducer"

export const getPlan = async(dispatch)=>{
    try {
        dispatch(loadingPlan());
        const data = await getDataSimple(PLANS);
        const dataP = await getDataSimple(PLANS+'/month');
        dispatch(successPlan({plans:data?.data,prices:dataP?.data}));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        dispatch(failedPlan());
        
    }
}

export const addPlan = async(dispatch,req,nav)=>{
    try {
        console.log(dispatch);
        dispatch(loadingPlan());
        const data = await postData(PLANS,req);
        await getPlan(dispatch);
        console.log('added',data);
        nav(-1);
        // const dataP = await getDataSimple(PLANS+'/month');
        // dispatch(successPlan({plans:data?.data,prices:dataP?.data}));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        console.log(error);
        dispatch(failedPlan());
        
    }
}

export const editPlan = async(dispatch,req)=>{
    try {
        console.log(dispatch);
        dispatch(loadingPlan());
        const data = await putData(PLANS,req);
        await getPlan(dispatch);
        console.log('added',data);
        // nav(-1);
        // const dataP = await getDataSimple(PLANS+'/month');
        // dispatch(successPlan({plans:data?.data,prices:dataP?.data}));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        console.log(error);
        dispatch(failedPlan());
        
    }
}

export const addPlanPrice = async(dispatch,req,nav)=>{
    try {
        console.log(dispatch);
        dispatch(loadingPlan());
        const data = await postData(PLANS+'/month',req);
        await getPlan(dispatch);
        console.log('added',data);
        nav(-1);
        // const dataP = await getDataSimple(PLANS+'/month');
        // dispatch(successPlan({plans:data?.data,prices:dataP?.data}));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        console.log(error);
        dispatch(failedPlan());
        
    }
}

export const editPlanPrice = async(dispatch,req)=>{
    try {
        console.log(dispatch);
        dispatch(loadingPlan());
        const data = await putData(PLANS+'/month',req);
        await getPlan(dispatch);
        console.log('added',data);
        // nav(-1);
        // const dataP = await getDataSimple(PLANS+'/month');
        // dispatch(successPlan({plans:data?.data,prices:dataP?.data}));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        console.log(error);
        dispatch(failedPlan());
        
    }
}

export const getBilling = async(dispatch)=>{
    try {
        dispatch(loadingBilling());
        const data = await getData(BILLING);
        console.log(data);
        dispatch(successBilling(data.data));
    } catch (error) {
        // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        dispatch(failedBilling());
        
    }
}

export const getCoupon = async(dispatch)=>{
    try {
        dispatch(loadingCoupons());
        const data = await getDataSimple(COUPON);
        dispatch(successCoupons(data.data));
    } catch (error) {
        // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        dispatch(failedCoupons());
        
    }
}


export const purchasePlan = async(dispatch,plan,month,coupon) =>{
    try {
        const data = await postData(PAYMENT,{
            plan_id:plan,month,coupon
        });

        dispatch(successCouponsSingle([]));
        window.location.href = data.data.url;
        console.log(data.data);
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        console.log(error);
    }
}



export const getCouponSearch = async(dispatch,coupon)=>{
    try {
        if(Boolean(coupon) && coupon !== ''){
            dispatch(loadingCoupons());
            const data = await getDataSimple(COUPON+'?coupon='+coupon);
            console.log(data.data);
            dispatch(successCouponsSingle(data.data));
        }
    } catch (error) {
        // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        dispatch(failedCoupons());
        
    }
}
export const addCoupon = async(dispatch,req,nav)=>{
    try {
        dispatch(loadingAddCoupon());
        const data = await postData(COUPON,req);
        await getCoupon(dispatch);
        nav(-1);
        // dispatch(successCoupons(data.data));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        dispatch(failedCoupons());
        
    }
}
export const updateCoupon = async(dispatch,req)=>{
    try {
        dispatch(loadingAddCoupon());
        const data = await putData(COUPON,req);
        await getCoupon(dispatch);
        // dispatch(successCoupons(data.data));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        dispatch(failedCoupons());
        
    }
}
export const activeCoupon = async(dispatch,req)=>{
    try {
        dispatch(loadingAddCoupon());
        const data = await patchData(COUPON,req);
        await getCoupon(dispatch);
        // dispatch(successCoupons(data.data));
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');
        dispatch(failedCoupons());
        
    }
}

